module.exports = __webpack_public_path__ + "fonts/roboto-lightitalic-webfont.ttf";